export default __webpack_public_path__ + "static/media/twitter.41bc13a0.svg";